import React from 'react';

interface LanderContextControlsType {
  scrollToProductSection: () => void;
}

export const LanderContextControls = React.createContext<LanderContextControlsType>(undefined as any);

export const LanderContextControlsProvider: React.FC<LanderContextControlsType> = ({ scrollToProductSection, children }) => {
  return <LanderContextControls.Provider value={{ scrollToProductSection }}>{children}</LanderContextControls.Provider>;
};

export const useLanderControls = (): LanderContextControlsType => {
  return React.useContext(LanderContextControls);
};

export default LanderContextControlsProvider;
